import React, { useState } from 'react';
import { Alert } from 'antd';

const PersistentAlert = ({ 
  id,           // Unique ID for localStorage
  message, 
  description, 
  type = "info", 
  ...rest       // Pass any other antd Alert props (showIcon, banner, etc.)
}) => {
  const storageKey = `alert_dismissed_${id}`;

  const [isVisible, setIsVisible] = useState(() => {
	// Check if this specific ID has been dismissed
	return localStorage.getItem(storageKey) !== 'true';
  });

  const handleClose = () => {
	setIsVisible(false);
	localStorage.setItem(storageKey, 'true');
  };

  if (!isVisible) return null;

  return (
	<Alert
	  message={message}
	  description={description}
	  type={type}
	  closable
	  onClose={handleClose}
	  {...rest}
	/>
  );
};

export default PersistentAlert;